export default {
  actions: {
    display: 'flex',
    justifyContent: 'flex-end',
  },
};
